import React from 'react';
import { Form } from 'react-bootstrap';
import { lang } from '../../../utils/langs';

const TaxTypeSelector = ({ selected, onSelect }) => {
  return (
    <Form.Group className="mb-3">
      <Form.Label>{lang('es', 'tax_type_filter') || 'Tipo de Impuesto'}</Form.Label>
      <Form.Select
        value={selected || 'all'}
        onChange={(e) => onSelect(e.target.value)}
      >
        <option value="all">{lang('es', 'todos') || 'Todos'}</option>
        <option value="1">{lang('es', 'impuestos') || 'Impuestos (IVA/Consumo)'}</option>
        <option value="2">{lang('es', 'retenciones') || 'Retenciones'}</option>
      </Form.Select>
    </Form.Group>
  );
};

export default TaxTypeSelector;
